const mobileAppBanner = document.querySelector(".mobile-app-banner");
const stickyHeader = document.querySelector(".sticky-header");
const header = document.querySelector(".header");
const closeBannerBtn = document.querySelector(".mobile-app-banner-close-btn");
const downloadAppBtn = document.querySelector(".mobile-app-download-btn");

const statusMobileAppBanner = localStorage ? localStorage.getItem("status-mobile-app-banner") : false;

if (!statusMobileAppBanner) {
  mobileAppBanner?.classList.add("mobile-app-banner-open");
  stickyHeader?.classList.add("sticky-header-mobile-app-banner");
  header?.classList.add("header-mobile-app-banner");
}

closeBannerBtn?.addEventListener("click", () => {
  hideMobileAppBanner();
})

downloadAppBtn?.addEventListener("click", () => {
  const userAgent = navigator.userAgent || navigator.vendor;
  let linkApp;

  if (userAgent.includes("Android")) {
    linkApp = 'https://play.google.com/store/apps/details?id=ru.zharpizza.mobile'
  } else {
    linkApp = 'https://apps.apple.com/us/app/%D0%B6%D0%B0%D1%80-%D0%BF%D0%B8%D1%86%D1%86%D0%B0/id1531691014'
  }

  window.open(linkApp, '_blank');
})

function hideMobileAppBanner() {
  mobileAppBanner.classList.remove("mobile-app-banner-open");
  stickyHeader?.classList.remove("sticky-header-mobile-app-banner");
  header.classList.remove("header-mobile-app-banner");

  if (localStorage) {
    localStorage.setItem("status-mobile-app-banner", true);
  }
}
